import type { UnitDefinition } from "./registry";

export const toBase = (unit: UnitDefinition, displayValue: number): number => displayValue * unit.factor + unit.offset;

export const fromBase = (unit: UnitDefinition, baseValue: number): number => (baseValue - unit.offset) / unit.factor;

const DECADE_PRECISION = 1e12;

// Resolution-preserving: a target unit that is N decades larger needs N more decimals to keep the
// entered resolution. Rounded before ceil so a float-noisy exact decade cannot add a spurious place.
export const dpFor = (target: UnitDefinition, ref: UnitDefinition, refDp: number): number => {
  const decades = Math.log10(target.factor / ref.factor);
  return Math.max(0, refDp + Math.ceil(Math.round(decades * DECADE_PRECISION) / DECADE_PRECISION));
};
